module.exports = __webpack_public_path__ + "img/modal-member.d6678efa.svg";